import { auth } from "@/main";
import axios from "axios";
import { store } from "../../store/store";
const pako = require('pako');

export default function getDataPerInterval(database, dataInicio, dataFim) {
  store.commit("incrementCarregando", true);
  dataInicio = `${dataInicio} 00:00`
  dataFim = `${dataFim} 23:59`
  return new Promise((resolve, reject) => {
    if (auth.currentUser != null) {
      auth.currentUser
        ?.getIdToken(true)
        .then((log) => {
          axios({
            method: "post",
            data: {
              empresa: database,
              dataInicio: dataInicio,
              dataFim: dataFim,

            },
            url: `${process.env.VUE_APP_APIURL}/pedidos/getdataperinterval`,
            headers: {
              authtoken: log,
            },
          })
            .then((res) => {
              store.commit("incrementCarregando", false);
              let data = res.data.result;
              let inflatedData = JSON.parse(pako.inflate(new Uint8Array(data.data), { to: 'string' }));
              res.data.result = inflatedData
              store.commit("incrementPedidosFinanceiro", res.data.result);
              resolve(res);
            })
            .catch((error) => {
              store.commit("incrementCarregando", false);
              reject(error);
            });
        })
        .catch((error) => {
          store.commit("incrementCarregando", false);
          reject(error);
        });
    } else {
      store.commit("incrementCarregando", false);
      resolve("Unauthorized");
    }
  });
}
